/* global swal  angular*/
import './style.less';
import moment from 'moment-timezone';

export default function($log, TimeZoneClass, EventClass) {
  'ngInject';

  const vm = this;
  const userGuessedTimeZoneId = moment.tz.guess();

  vm.$onInit = activate;
  vm.activate = activate;
  vm.timeZoneList = TimeZoneClass.selectList;

  vm.hasExternalWebinar = () => {
    return !!EventClass.externalWebinars(vm.event).length;
  };

  function setType() {
    if (vm.event.webinarKey) return (vm.event.type = 'goToWebinar');
    if (vm.event.zoomWebinarId) return (vm.event.type = 'zoom');
    if (vm.event.zoomMeetingId) return (vm.event.type = 'zoomMeeting');
    if (vm.event.webexType === 'training') return (vm.event.type = 'webex');
    if (vm.event.webexType === 'event') return (vm.event.type = 'webexEvent');
    if (vm.event.url) return (vm.event.type = 'other');
    vm.event.type = 'external';
  }

  function activate() {
    $log.debug('Webinar Editor Component Activated');
    vm.event.delivery_location = 'Webinar';
    vm.event.delivery_location_time_zone_id = vm.event.delivery_location_time_zone_id || userGuessedTimeZoneId;
    vm.event.waitlist = vm.event.waitlist || 'automatic';
    vm.error = false;
    vm.loaded = true;
    setType();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/webinarEditor/controller.js